import type { Vec3 } from "eutopia.ts";
import { createLayer, createLayerType, vec3Transition } from "eutopia.ts";
import { $, resolve } from "signlets";

import { positionEmpty } from "../position";
import { blue, scaleOpacity } from "./color";
import { marker } from "./marker";

export type TargetProps = {
  position: Vec3;
};

export const target = createLayerType<TargetProps>(
  (context, { position: position_ }) => {
    const position = vec3Transition($(() => resolve(position_)));
    const color = $(() =>
      scaleOpacity(blue, positionEmpty(position()) ? 0 : 1),
    );
    return createLayer(
      context,
      marker({
        markers: [{ position, color, pickable: false }],
      }),
    );
  },
);
